var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38154 15.9997C5.80058 15.9997 6.14344 15.6568 6.14344 15.2378L6.15106 5.39398L9.35106 8.36541C9.49582 8.50255 9.6863 8.57113 9.86916 8.57113C10.0749 8.57113 10.2806 8.48732 10.4253 8.32732C10.7149 8.01494 10.692 7.53494 10.3873 7.25303L5.85392 3.0397C5.70916 2.90256 5.5263 2.8416 5.34344 2.83398C5.33582 2.83398 5.32821 2.83398 5.32059 2.83398C5.31297 2.83398 5.30535 2.83398 5.30535 2.83398C5.12249 2.83398 4.93963 2.90256 4.79487 3.03208L0.2463 7.23779C-0.0660809 7.5197 -0.0813183 8.00732 0.200586 8.31208C0.352967 8.47208 0.558682 8.55589 0.756777 8.55589C0.939634 8.55589 1.13011 8.48732 1.27487 8.35018L4.61963 5.25684V15.2378C4.61963 15.6568 4.96249 15.9997 5.38154 15.9997Z",
    fill: "#001737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.841006 1.52381L9.80863 1.53143C10.2277 1.53143 10.5705 1.18857 10.5705 0.769524C10.5705 0.350477 10.2277 0.00761951 9.80863 0.00761951L0.841006 0C0.421959 0 0.0791016 0.342857 0.0791016 0.761905C0.0791016 1.18095 0.421959 1.52381 0.841006 1.52381Z",
    fill: "#001737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUpload);
export default __webpack_public_path__ + "static/media/single-upload.68e6e9a7e4217756bef3cceeb62066bc.svg";
export { ForwardRef as ReactComponent };